export default __webpack_public_path__ + "static/media/banner4.6a399838.jpg";